import {createStrokeSVG} from './TEMPLATE'

// tabler: mood-smile
export const EmojiArc_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M9 10l.01 0',
    'M15 10l.01 0',
    'M9.5 15a3.5 3.5 0 0 0 5 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: mood-sad
export const EmojiSad_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M9 10l.01 0',
    'M15 10l.01 0',
    'M9.5 15.25a3.5 3.5 0 0 1 5 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: mood-smile
export const EmojiSmile_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M9 10l.01 0',
    'M15 10l.01 0',
    'M9.5 15a3.5 3.5 0 0 0 5 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
